import http from './http'

const admin = {
  async getParticipants (args) {
    console.log('[admin]getParticipants')
    const { data } = await http.api.get('/admin/inscriptions', args)
    data.list.forEach(one => {
      one.classes = one.classes || []
      one.nbStudents = 0
      if (one.classes.length) {
        one.nbStudents = one.classes.map(one => one.nbStudents).reduce((val, acc) => val + acc)
      }
    })
    return data
  },

  async updateParticipantHasPaid (args) {
    console.log('[admin]updateParticipantHasPaid')
    const { data } = await http.api.put('/admin/inscriptions/has-paid', args)
    return data
  },

  async updateParticipantPaymentMode (args) {
    console.log('[admin]updateParticipantPaymentMode')
    const { data } = await http.api.put('/admin/inscriptions/payment-mode', args)
    return data
  },

}

export default admin
